var _circle, _circle2, _circle3, _circle4, _ellipse, _path, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle29, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetrics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 205,
    viewBox: "0 0 206 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.049,
    cy: 41.5156,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.976,
    cy: 59.1768,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.456,
    cy: 68.2462,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 200.069,
    cy: 98.3181,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.308,
    cy: 100.347,
    rx: 68.2583,
    ry: 67.6616,
    fill: "#787E8C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.566 100.347C167.566 137.155 137.462 167.009 100.308 167.009C63.1536 167.009 33.0493 137.155 33.0493 100.347C33.0493 63.539 63.1536 33.6853 100.308 33.6853C137.462 33.6853 167.566 63.539 167.566 100.347Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.61489,
    cy: 69.6784,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.1662,
    cy: 181.851,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.6701,
    cy: 192.83,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.95,
    cy: 179.942,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 123.697,
    cy: 177.078,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 128.47,
    cy: 190.92,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 109.854,
    cy: 196.648,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 174.293,
    cy: 166.815,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 189.568,
    cy: 138.414,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 180.26,
    cy: 123.617,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 184.079,
    cy: 93.5446,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 191.955,
    cy: 77.3156,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 186.466,
    cy: 40.7996,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 73.8159,
    cy: 199.035,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 39.6865,
    cy: 194.262,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 44.4599,
    cy: 185.908,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 13.4331,
    cy: 147.722,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 20.3545,
    cy: 132.925,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2.69333,
    cy: 94.4994,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 21.5478,
    cy: 64.6665,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 25.3667,
    cy: 22.4226,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 61.8823,
    cy: 6.19333,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 108.422,
    cy: 24.8093,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.436,
    cy: 18.8425,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.475 150.347C169.421 150.347 168.566 149.493 168.566 148.438C168.566 147.384 169.421 146.529 170.475 146.529",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51221 117.65C7.5667 117.65 8.42153 116.795 8.42153 115.741C8.42153 114.686 7.5667 113.831 6.51221 113.831",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5317 22.4228C75.5862 22.4228 76.4411 21.5679 76.4411 20.5134C76.4411 19.459 75.5862 18.6041 74.5317 18.6041",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.833 15.7399C119.779 15.7399 118.924 16.5948 118.924 17.6493C118.924 18.7038 119.779 19.5586 120.833 19.5586",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3306 166.934H16.2972M26.3211 155.836V157.388M38.0157 166.934H39.5671M26.3211 176.481V178.271M26.3211 180.658V186.982M21.9058 166.934C24.8892 166.934 26.4405 162.638 26.4405 162.638C26.4405 162.638 26.9178 166.934 30.7365 166.934C29.0181 166.934 26.5598 168.486 26.3211 171.588C26.3211 171.588 26.0432 169.048 25.1278 168.128C24.3635 167.359 21.9058 166.934 21.9058 166.934Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178.709 30.0597L172.742 30.0597M162.599 45.8116L162.718 39.6063M151.024 30.0597L149.472 30.0597M162.599 20.7518L162.599 8.57985M167.134 30.0597C164.15 30.0597 162.599 34.3557 162.599 34.3557C162.599 34.3557 162.122 30.0597 158.303 30.0597C160.021 30.0597 162.48 28.5084 162.718 25.4057C162.718 25.4057 162.996 27.9459 163.912 28.8664C164.676 29.635 167.134 30.0597 167.134 30.0597Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65 66.5V141C65 142.657 66.3431 144 68 144H183.5",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 50,
    r: 16,
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0878 51.4071C68.8156 50.8736 68.4059 50.4092 67.8697 50.0276C67.3663 49.6691 66.6053 49.3126 65.5435 48.9376C64.4185 48.5402 63.8993 48.185 63.6625 47.958C63.3846 47.6903 63.2497 47.3094 63.2497 46.7923C63.2497 46.2503 63.4036 45.8365 63.7214 45.5273C64.05 45.2063 64.5204 45.0504 65.1605 45.0504C65.7702 45.0504 66.2305 45.2431 66.5661 45.6391C66.9231 46.0608 67.0973 46.6364 67.0973 47.3982V47.7837C67.0973 47.9429 67.2214 48.0719 67.3746 48.0719H69.1284C69.2816 48.0719 69.4057 47.9429 69.4057 47.7837V47.3982C69.4057 46.0694 69.079 44.9892 68.4344 44.1879C67.9349 43.5656 67.2802 43.1446 66.4812 42.9295C66.3578 42.8959 66.2685 42.7841 66.2685 42.6512V41.2881C66.2685 41.1289 66.1444 41 65.9912 41H64.3817C64.2285 41 64.1044 41.1289 64.1044 41.2881V42.6394C64.1044 42.7742 64.0126 42.888 63.8866 42.9189C63.1237 43.1084 62.4842 43.4728 61.9784 44.0057C61.2902 44.7313 60.9413 45.6766 60.9413 46.8154C60.9413 47.9002 61.2604 48.8054 61.8897 49.506C62.4893 50.173 63.4618 50.7197 64.8471 51.171C66.0127 51.5907 66.5331 51.9597 66.7655 52.1959C67.046 52.4814 67.1827 52.8485 67.1827 53.3175C67.1827 53.8399 67.0137 54.2332 66.6503 54.5536C66.2609 54.8977 65.7537 55.0648 65.1016 55.0648C64.3463 55.0648 63.7872 54.8714 63.3941 54.474C63.0053 54.0813 62.8166 53.5326 62.8166 52.7965V52.411C62.8166 52.2518 62.6925 52.1229 62.5393 52.1229H60.7773C60.6241 52.1229 60.5 52.2518 60.5 52.411V52.7965C60.5 54.1326 60.8761 55.2128 61.6181 56.0088C62.1892 56.6206 62.9382 57.0251 63.8518 57.2166C63.9829 57.2442 64.0791 57.3593 64.0791 57.4981V58.7119C64.0791 58.8711 64.2032 59 64.3564 59H65.9576C66.1108 59 66.2349 58.8711 66.2349 58.7119V57.4738C66.2349 57.3376 66.3286 57.2232 66.4565 57.1936C67.2511 57.008 67.914 56.6475 68.4344 56.1173C69.1416 55.397 69.5 54.449 69.5 53.2998C69.4987 52.5788 69.3607 51.942 69.0878 51.4071Z",
    fill: "#787E8C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M184 114L161.231 120.641C160.445 120.87 159.599 120.768 158.89 120.359L137.8 108.173C137.601 108.058 137.415 107.92 137.247 107.763L115.35 87.2064C114.08 86.0143 112.066 86.1505 110.968 87.5026L65.5 143.5",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M184 102L161.062 103.873C160.083 103.952 159.128 103.548 158.503 102.791L138.8 78.8955C137.455 77.2643 134.889 77.4989 133.863 79.3471L116.277 111.002C115.102 113.116 112.037 113.043 110.965 110.875L93.7122 75.9943C92.5271 73.5983 89.0366 73.8317 88.181 76.3642L65.5 143.5",
    stroke: "#194590",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetrics);
export default __webpack_public_path__ + "static/media/metrics.82f66bc2ff5cef7a45ebebcf1bf09c7e.svg";
export { ForwardRef as ReactComponent };